import React from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import ContactSteps from "../../components/ContactPageComponents/ContactSteps";
import ContactForm from "../../components/ContactPageComponents/ContactForm";
import AreaServe from "../../components/HomePageComponents/AreaServe/AreaServe";

const Contact = () => {
  return (
    <section id="contact page" style={{ backgroundColor: "#FBFBFE" }}>
      <Container maxWidth="lg" sx={{ padding: "160px 0 30px" }}>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={5}>
            <Grid item xs={12} sm={12} md={3}>
              <Typography variant="h3" gutterBottom>
                What will happen next?
              </Typography>
              <Typography
                variant="body1"
                component="p"
                gutterBottom
                sx={{
                  mb: 3.7,
                  lineHeight: 1.55,
                  letterSpacing: "-0.14px",
                }}
              >
                We will get back to you within 24 hours
              </Typography>
              <Typography
                variant="body1"
                component="p"
                gutterBottom
                sx={{
                  mb: 3.7,
                  lineHeight: 1.55,
                  letterSpacing: "-0.14px",
                }}
              >
                You are a step closer to building great software
              </Typography>
              {/* import left side step component */}
              <ContactSteps />
            </Grid>
            <Grid item xs={12} sm={12} md={9}>
              <ContactForm />
            </Grid>
          </Grid>
        </Box>
      </Container>
    </section>
  );
};

export default Contact;
